import { useEffect, useRef, useState } from 'react';

const THRESHOLD = 80;
const MAX_PULL = 120;

export default function PwaPullToRefresh({ children }) {
  const startYRef = useRef(0);
  const pullingRef = useRef(false);
  const [pull, setPull] = useState(0);
  const [armed, setArmed] = useState(false);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const standalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;
    setEnabled(standalone);
    if (!standalone) return () => {};

    const onTouchStart = (event) => {
      if (window.scrollY > 0) return;
      const touch = event.touches?.[0];
      if (!touch) return;
      startYRef.current = touch.clientY;
      pullingRef.current = true;
    };

    const onTouchMove = (event) => {
      if (!pullingRef.current) return;
      const touch = event.touches?.[0];
      if (!touch) return;
      const delta = Math.max(0, touch.clientY - startYRef.current);
      if (delta === 0) return;
      event.preventDefault();
      const nextPull = Math.min(MAX_PULL, delta);
      setPull(nextPull);
      setArmed(nextPull > THRESHOLD);
    };

    const onTouchEnd = () => {
      if (!pullingRef.current) return;
      pullingRef.current = false;
      if (armed) {
        setPull(THRESHOLD);
        setTimeout(() => {
          window.location.reload();
        }, 150);
      } else {
        setPull(0);
      }
      setArmed(false);
    };

    window.addEventListener('touchstart', onTouchStart, { passive: true });
    window.addEventListener('touchmove', onTouchMove, { passive: false });
    window.addEventListener('touchend', onTouchEnd, { passive: true });

    return () => {
      window.removeEventListener('touchstart', onTouchStart);
      window.removeEventListener('touchmove', onTouchMove);
      window.removeEventListener('touchend', onTouchEnd);
    };
  }, [armed]);

  if (!enabled) {
    return children;
  }

  return (
    <div className="pwa-pull">
      <div className="pwa-pull__indicator" style={{ height: pull }}>
        <div className={`pwa-pull__bubble${armed ? ' is-armed' : ''}`}>
          <span>{armed ? 'Release to refresh' : 'Pull to refresh'}</span>
        </div>
      </div>
      {children}
    </div>
  );
}
